import { ChangeDetectionStrategy, Component, computed, effect, inject, Input, input, OnInit, output, Signal, signal, viewChild } from "@angular/core";

import { FormsModule } from "@angular/forms";
import { AgGridAngular, AgGridModule } from "ag-grid-angular";
import { AgGridService, GridInitOption, JkPaginatorService, MaterialModule, JkExcelService, jkLib, iif } from "jk-service";
import { JkBaseComponent } from "jk-service";
import { CellValueChangedEvent, ColDef, GridApi, GridReadyEvent, RowClickedEvent, RowDoubleClickedEvent, RowEditingStartedEvent, RowEditingStoppedEvent, RowSelectedEvent, RowSelectionOptions } from "ag-grid-community";
import { MatPaginator } from "@angular/material/paginator";
import { idNameItem, jkRestReturn } from 'jk-service';
//import { BookType } from "xlsx";



@Component({
  selector: 'app-jkgrid-father-base',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(window:resize)': 'onWindowResize($event)',
  },
  imports: [
    FormsModule,
    AgGridModule,
    MaterialModule
],
  templateUrl: './jkgrid-base-father.component.html',
  styles: [],
})

export class JkGridBaseFatherComponent extends JkBaseComponent implements OnInit {
  override comType = 'jkgridbase-father';
  isJkaggrid = false;
  columnsCount: number = 0;
  programId: string = '';
  //defaultHeight = 300;
  defaultHeight = input<number>(300);
  readonly valueChange = output<any>();
  //afterColumnDefs = output<ColDef[]>();
  readonly afterColumnDefs = output<ColDef[]>();
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input()
  columnDefs: ColDef[] = [];
  updateColumnsCount() {
    this.columnsCount = this.columnDefs ? this.columnDefs.length : 0;
  }
  itemListChange = output<any[]>();
  paramsChange = output<any[]>();
  rowSelected = output<RowSelectedEvent<any, any>>();
  rowClicked = output<RowClickedEvent<any, any>>();
  doubleClick = output<RowDoubleClickedEvent<any, any>>();
  selectedRows = output<any[]>();

  paginator!: MatPaginator; // = viewChild<MatPaginator>('gridwinPaginator');
  pageSrv: JkPaginatorService = new JkPaginatorService();
  valueExpr = input<string>('id');
  displayExpr = input<string>('name');
  onFocusedRowChanged!: (e: any) => void;
  selectedItem: any;
  _excelFileName: string = '';
  get excelFileName(): string {
    if (this._excelFileName === '') {
      return this.programId;
    } else {
      return this._excelFileName;
    }
  }
  set excelFileName(value: string) {
    this._excelFileName = value;
  }
  doMyExportExcel(itemList: any[]) {
    this.doExportExcel(itemList, this.excelFileName);
  }

  gridSrv: AgGridService = inject(AgGridService);

  set gridApi(value: GridApi) {
    if (this.gridSrv) this.gridSrv.gridApi = value;
    else alert('jkaggrid.gridSrv is null');
  }
  get gridApi(): GridApi {
    return this.gridSrv.gridApi;
  }

  constructor() {
    super();
    this.updateColumnsCount();
    this.bookTypeItem = this.xls.bookTypeList[0];
  }
  override ngOnInit() {
    super.ngOnInit();
    this.updateColumnsCount();
    // itemListInput 的同步現在由 constructor 中的 effect 處理
    // 無需手動賦值，effect 會自動響應變化
  }

  init(opt: GridInitOption) {
    this.gridSrv.init(opt);
  }
  isEditing: boolean = false;
  onCellValueChanged($event: CellValueChangedEvent<any, any>) {
    this.isEditing = true;
  }
  onKeydown(event: KeyboardEvent) {

  }



  onRowEditingStarted(event: RowEditingStartedEvent<any, any>) {
  }
  /**
   * @method onRowEditingStopped
   * @description 行編輯結束事件處理
   * @param {RowEditingStoppedEvent<any, any>} $event - 行編輯結束事件
   */
  onRowEditingStopped($event: RowEditingStoppedEvent<any, any>) {
  }
  // Convert @Output() to output() signals
  //afterGridReady = output<JkgridwinComponent>();
  readonly afterGridReady = output<any>();
  //afterQuery = output<any>();
  readonly afterQuery = output<any>();
  //valueChange = output<any>();
  /**
   * @property {AgGridAngular} grid - AG Grid 元件引用
   */
  grid = viewChild<AgGridAngular>('myGrid');
  get defaultColDef(): ColDef {
    return this.gridSrv.defaultColDef;
  }
  set defaultColDef(value: ColDef) {
    this.gridSrv.defaultColDef = value;
  }
  get focusedRowIndex(): number {
    if (this.rowIndex === undefined) return -1;
    if (this.rowIndex === null) return -1;
    else return this.rowIndex;
  }
  set focusedRowIndex(value: number) {
    this.rowIndex = value;
  }
  get rowIndex(): number | null {
    return this.gridSrv.rowIndex;
  }
  set rowIndex(value: number) {
    this.gridSrv.rowIndex = value;
  }
  onLastRow() {
    this.gridSrv.goLastRow();
  }

  onFirstRow() {
    this.gridSrv.goFirstRow();
  }
  rowSelectionOpt: RowSelectionOptions = {
    mode: 'singleRow',
    checkboxes: false,
  };
  // Internal state
  private _isMultiSelect: boolean = false;

  set isMultiSelect(value: boolean) {
    this._isMultiSelect = value;
    if (value) {
      this.rowSelectionOpt.mode = 'multiRow';
    } else {
      this.rowSelectionOpt.mode = 'singleRow';
      this.rowSelectionOpt.checkboxes = false;
    }
    this.gridSrv.rowSelection = this.rowSelectionOpt;
  }
  get isMultiSelect(): boolean {
    return this._isMultiSelect;
  }
  /**
   * @property {JkExcelService} xls - Excel 服務實例，用於匯出功能
   */
  public xls: JkExcelService = new JkExcelService();
  /**
   * @property {idNameItem} bookTypeItem - 匯出檔案類型項目
   */
  bookTypeItem: idNameItem;

  /**
   * @property {idNameItem[]} bookTypeList - 可用的匯出檔案類型列表
   */
  get bookTypeList() {
    if (!this.xls) return [];
    return this.xls.bookTypeList;
  }
  onRowSelected($event: RowSelectedEvent<any, any>) {
    if (this.rowSelected) {
      this.rowSelected.emit($event);
    }
  }
  onGridReady(event: GridReadyEvent) {
    this.gridSrv.gridApi = event.api;
    this.gridSrv.init(this.gridSrv.gridInitOpt);
    this.gridSrv.setRowSelectionOpt(this.isMultiSelect);
    //this.getColumnDefs(true); 開窗元件才需要

    if (this.afterGridReady) {
      this.afterGridReady.emit(this);
    }
    this.onWindowResize();
  }
  /**
   * @method doUIInsert
   * @description 觸發新增操作
   */
  doUIInsert() { }
  doSetup() { }
  doUIDelete() { }
  doUIEdit() { }
  doRefresh() {
  }

  //gridVisible: boolean = true;
  doUIRefresh(isResetPage = true) {
    /*this.gridVisible = false;
    setTimeout(() => {
      this.gridVisible = true;
      this.cdr.markForCheck();
    }, 1);
    */
  }
  gridFilterValue: string = '';
  doFilter(value: string) {
    this.page
      .showInput('輸入', '過濾條件:', value)
      .subscribe((filter: string) => {
        if (filter) {
          this.gridFilterValue = filter;
          this.quickFilter(filter);
        }
      });
  }

  quickFilter(value: string) {
    if (this.gridSrv && this.gridSrv.gridApi)
      try {
        this.gridSrv.gridApi.setGridOption('quickFilterText', value);
      } catch (error: any) {
        console.error('quickFilter error:', error.message);
      }
  }
  onPreviousRow() {
    if (this.pageSrv.length === 0) {
      this.gridSrv.focusPreviousRow();
      const data = this.gridSrv.getFocusedRowData();
      if (this.onFocusedRowChanged) this.onFocusedRowChanged(data);
    } else {
      const gridInstance = this.grid();
      if (!gridInstance) return;
      const currentIndex = gridInstance.api.getFocusedCell()?.rowIndex ?? 0;
      if (currentIndex > 0) {
        gridInstance.api.setFocusedCell(currentIndex - 1, 'make');
      } else if (this.pageSrv.pageIndex > 0) {
        this.pageSrv.pageIndex--;
        gridInstance.api.setFocusedCell(this.pageSrv.pageSize - 1, 'make');
      }
    }
  }
  _searchValue: string = '';
  set searchValue(value: string) {
    this._searchValue = value;
  }
  get searchValue(): string {
    return this._searchValue;
  }

  gridSearchValue: string = '';
  searchGrid(value: string) {
    this.gridSrv.searchGrid(value, this.columnDefs, this.cdr);
  }
  clearSearchValue() {
    this.searchValue = '';
    this.quickFilter(this.searchValue);
  }
  onFilterTextBoxChanged($event: any) {
    let str = $event.trim();
    this.gridFilterValue = str;
    this.gridApi.setGridOption('quickFilterText', this.gridFilterValue);
  }
  /**
   * Note: sortFields has been disabled because columnDefs is an InputSignal
   * and cannot be modified from within this component. Column sorting should
   * be handled by the parent component that controls the columnDefs input.
   */
  sortFields(fieldList: string) {
    if ((fieldList === '') || (fieldList === undefined)) return;
    console.warn(
      'sortFields is disabled - columnDefs cannot be modified internally. Use a signal or handle sorting in parent component.'
    );
    // Note: ColumnDefs is readonly InputSignal - sorting should be done at parent level
    // this.updateColumnsCount();
  }
  reloadGrid() {
    this.gridSrv.reloadGrid();
  }
  resort() {
    if (this.gridSrv.sortField !== '') {
      this.gridSrv.resort();
    }
  }


  refresh() {
    if (this.gridSrv.gridApi) {
      this.gridSrv.gridApi.redrawRows();
    }
    else alert('jkaggrid.refresh gridApi is null');
  }

  selectedRowsData: any[] = [];
  onSelectionChanged() {
    if (this.isMultiSelect) {
      try {
        this.selectedRowsData = this.gridApi.getSelectedRows();
      } catch (error: any) {
        alert('onSelectionChanged error:' + error);
      }
    } else {
      try {
        this.selectedRowsData = this.gridApi.getSelectedRows();
      } catch (error: any) {
        alert('onSelectionChanged error:' + error);
      }
    }
  }
  itemListLength(): number {
    return 0;
  }
  onNextRow() {
    if (this.pageSrv.length === 0) {
      this.gridSrv.focusNextRow();
      const data = this.gridSrv.getFocusedRowData();
      if (this.onFocusedRowChanged) this.onFocusedRowChanged(data);
    } else {
      const gridInstance = this.grid();
      if (!gridInstance) return;
      const currentIndex = gridInstance.api.getFocusedCell()?.rowIndex ?? 0;
      if (currentIndex < this.pageSrv.pageSize - 1) {
        gridInstance.api.setFocusedCell(currentIndex + 1, 'make');
      } else if (
        (this.pageSrv.pageIndex + 1) * this.pageSrv.pageSize <
        this.itemListLength()
      ) {
        this.pageSrv.pageIndex++;
        gridInstance.api.setFocusedCell(0, 'make');
      }
    }
  }
  doShowInfo($event: MouseEvent) {
  }
  onRowClicked($event: RowClickedEvent<any, any>) {
    if ($event.rowIndex) this.focusedRowIndex = $event.rowIndex;
    if ($event.data) this.selectedItem = $event.data;
    if (this.rowClicked) {
      this.rowClicked.emit($event);
    }
  }
  onRowDoubleClicked($event: RowDoubleClickedEvent<any, any>) {
    if (this.isMultiSelect) {
      this.selectedItem = $event.data;
    } else {
      this.selectedItem = $event.data;
    }
    if (this.doubleClick) {
      this.doubleClick.emit($event);
    }
  }
  doExportExcel(itemList: any[], fileName: string) {
    const xls = new JkExcelService();
    let headerNames: string[] = [];
    for (let i = 0; i < this.columnDefs.length; i++) {
      let col = this.columnDefs[i];
      headerNames.push(col.headerName as string);
    }
    let fn = fileName + iif(fileName === '', '', '-') + jkLib.nowDate() + '-' + jkLib.nowTime6() + '.xlsx';
    // 彈出輸入對話,輸入文件名稱
    this.page.showInput('輸入文件名稱', '文件名稱', fn, 'text').subscribe({
      next: (data) => {
        if (data) {
          xls.jsonExportXlsx(
            itemList,
            data,
            headerNames
          );
        };
      }
    })
  }
  addEditDelButton() {
    // FIXME: 按鈕沒顯示
    /*
    if(!this.readonly()){
      this.columnDefs.unshift(this.gridSrv.agEditColumnDef);
      this.columnDefs.unshift(this.gridSrv.agDeleteColumnDef);
      //this.refresh();
      this.reloadGrid();
    }*/
  }
  /**
     * @property {string} _seekFields - 內部儲存的查詢欄位
     */
  _seekFields: string = '';

  /**
   * @property {string} seekFields - 查詢欄位，逗號分隔的字串
   * @description 設定查詢欄位並控制查詢面板的可見性
   */
  seekFields = input<string>('');
  // Deprecated - use searchGrid instead
  seek(value: string, seekFields: string) {
    if (seekFields === '') {
      this.columnDefs.forEach((col: ColDef) => {
        if (
          col.field &&
          col.cellDataType !== 'number' &&
          col.cellDataType !== 'object'
        ) {
          seekFields += jkLib.iif(seekFields === '', '', ',') + col.field;
        }
      });
    }
    this.gridSrv.seek(value, seekFields);
  }


}
